import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Params } from '@angular/router';

import { Observable, Subject } from 'rxjs';

import { AlertDialogComponent } from '@shared/dialogs/alert-dialog/alert-dialog.component';
import { environment as env } from '@environments/environment';

interface IErrorDialog {
  title?: string;
  body?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  hasDialog: boolean;
  hasTechnicalDialog: boolean;
  serverError$ = new Subject<IErrorDialog>();
  show$ = new Subject<IErrorDialog>();

  private readonly dialog = inject(MatDialog);
  private readonly http = inject(HttpClient);

  showAlert(params: Params, id?: string): Observable<any> {
    return this.dialog.open(AlertDialogComponent, { data: params, maxWidth: '90vw', id }).afterClosed();
  }

  send(data: Params): Observable<any> {
    return this.http.post(`${env.webApi}/web-app-log`, data);
  }
}
